import type React from 'react'
import {createContext, use} from 'react'

import type {CommitPayload} from '../types/commit-types'

const CommitPayloadContext = createContext<CommitPayload | null>(null)

export function CommitPayloadProvider({payload, children}: {payload: CommitPayload; children?: React.ReactNode}) {
  return <CommitPayloadContext value={payload}>{children}</CommitPayloadContext>
}

export function useCommitPayload(): CommitPayload {
  const payload = use(CommitPayloadContext)

  if (!payload) {
    throw new Error('useCommitPayload must be used within a CommitPayloadProvider')
  }

  return payload
}
